exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[data-v-1d6db9e4] .gl-general-open-row td { background: #fbfbfb !important;\n}\n[data-v-1d6db9e4] .gl-general-total-row td { background: #fafafa !important; font-weight: 600;\n}\n", ""]);

// exports
